/**
 * Inventory Module Service
 * API service layer for Inventory screens
 * All API endpoints from API_REGISTRY.md
 */

import api from '../apiClient';

// ═══════════════════════════════════════════════════════════════════════════════
// STOCK VERIFY SCHEDULE
// ═══════════════════════════════════════════════════════════════════════════════
export const stockVerifySchedule = {
  getAll: () => api.get('/api/StockVerifySchedule/api/V1/GetAllSchedules'),
  getById: (scheduleId) => api.get(`/api/StockVerifySchedule/api/V1/GetScheduleById?scheduleId=${scheduleId}`),
  save: (data) => api.post('/api/StockVerifySchedule/api/V1/Save', data),
  update: (data) => api.put('/api/StockVerifySchedule/api/V1/Update', data),
  delete: (scheduleId) => api.delete(`/api/StockVerifySchedule/api/V1/Delete?scheduleId=${scheduleId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// STOCK VERIFY ENTRY
// ═══════════════════════════════════════════════════════════════════════════════
export const stockVerifyEntry = {
  getAll: () => api.get('/api/StockVerifyEntry/api/V1/GetAllEntries'),
  getById: (entryId) => api.get(`/api/StockVerifyEntry/api/V1/GetEntryById?entryId=${entryId}`),
  save: (data) => api.post('/api/StockVerifyEntry/api/V1/Save', data),
  update: (data) => api.put('/api/StockVerifyEntry/api/V1/Update', data),
  delete: (entryId) => api.delete(`/api/StockVerifyEntry/api/V1/Delete?entryId=${entryId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// VERIFY UPDATE STOCK
// ═══════════════════════════════════════════════════════════════════════════════
export const verifyUpdateStock = {
  getAll: () => api.get('/api/VerifyUpdateStock/api/V1/GetAllUpdates'),
  getById: (updateId) => api.get(`/api/VerifyUpdateStock/api/V1/GetUpdateById?updateId=${updateId}`),
  save: (data) => api.post('/api/VerifyUpdateStock/api/V1/Save', data),
  update: (data) => api.put('/api/VerifyUpdateStock/api/V1/Update', data),
};

// ═══════════════════════════════════════════════════════════════════════════════
// SHORTAGE STOCK
// ═══════════════════════════════════════════════════════════════════════════════
export const shortageStock = {
  getAll: () => api.get('/api/ShortageStock/api/V1/GetAllShortages'),
  getByFilter: (branchId, fromDate, toDate) => 
    api.get(`/api/ShortageStock/api/V1/GetShortagesByFilter?branchId=${branchId}&fromDate=${fromDate}&toDate=${toDate}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// EXCESS STOCK
// ═══════════════════════════════════════════════════════════════════════════════
export const excessStock = {
  getAll: () => api.get('/api/ExcessStock/api/V1/GetAllExcess'),
  getByFilter: (branchId, fromDate, toDate) => 
    api.get(`/api/ExcessStock/api/V1/GetExcessByFilter?branchId=${branchId}&fromDate=${fromDate}&toDate=${toDate}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// PHYSICAL STOCK WITH PDA
// ═══════════════════════════════════════════════════════════════════════════════
export const physicalStockPDA = {
  getAll: () => api.get('/api/PhysicalStockPDA/api/V1/GetAllScans'),
  uploadScan: (data) => api.post('/api/PhysicalStockPDA/api/V1/UploadScan', data),
  processScans: (data) => api.post('/api/PhysicalStockPDA/api/V1/ProcessScans', data),
};

// ═══════════════════════════════════════════════════════════════════════════════
// ROL SETTINGS (REORDER LEVEL)
// ═══════════════════════════════════════════════════════════════════════════════
export const rolSettings = {
  getAll: () => api.get('/api/ROLSettings/api/V1/GetAllSettings'),
  getById: (itemCode) => api.get(`/api/ROLSettings/api/V1/GetSettingsByItemCode?itemCode=${itemCode}`),
  save: (data) => api.post('/api/ROLSettings/api/V1/Save', data),
  update: (data) => api.put('/api/ROLSettings/api/V1/Update', data),
  delete: (itemCode) => api.delete(`/api/ROLSettings/api/V1/Delete?itemCode=${itemCode}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// PRICE UPDATE
// ═══════════════════════════════════════════════════════════════════════════════
export const priceUpdate = {
  getAll: () => api.get('/api/PriceUpdate/api/V1/GetAllItems'),
  getById: (itemCode) => api.get(`/api/PriceUpdate/api/V1/GetItemById?itemCode=${itemCode}`),
  updatePrice: (data) => api.put('/api/PriceUpdate/api/V1/UpdatePrice', data),
  bulkUpdate: (data) => api.post('/api/PriceUpdate/api/V1/BulkUpdatePrice', data),
};

// ═══════════════════════════════════════════════════════════════════════════════
// TOKEN UPDATE
// ═══════════════════════════════════════════════════════════════════════════════
export const tokenUpdate = {
  getAll: () => api.get('/api/TokenUpdate/api/V1/GetAllTokens'),
  getById: (tokenId) => api.get(`/api/TokenUpdate/api/V1/GetTokenById?tokenId=${tokenId}`),
  update: (data) => api.put('/api/TokenUpdate/api/V1/Update', data),
};

// ═══════════════════════════════════════════════════════════════════════════════
// BULK PRODUCT UPDATION
// ═══════════════════════════════════════════════════════════════════════════════
export const bulkProductUpdation = {
  getAll: () => api.get('/api/BulkProductUpdation/api/V1/GetAllProducts'),
  update: (data) => api.put('/api/BulkProductUpdation/api/V1/BulkUpdate', data),
};

// ═══════════════════════════════════════════════════════════════════════════════
// OEM CODE UPDATE
// ═══════════════════════════════════════════════════════════════════════════════
export const oemCodeUpdate = {
  getAll: () => api.get('/api/OEMCodeUpdate/api/V1/GetAllItems'),
  update: (data) => api.put('/api/OEMCodeUpdate/api/V1/Update', data),
};

// ═══════════════════════════════════════════════════════════════════════════════
// ITEM CONVERSION
// ═══════════════════════════════════════════════════════════════════════════════
export const itemConversion = {
  getAll: () => api.get('/api/ItemConversion/api/V1/GetAllConversions'),
  getById: (conversionId) => api.get(`/api/ItemConversion/api/V1/GetConversionById?conversionId=${conversionId}`),
  save: (data) => api.post('/api/ItemConversion/api/V1/Save', data),
  update: (data) => api.put('/api/ItemConversion/api/V1/Update', data),
  delete: (conversionId) => api.delete(`/api/ItemConversion/api/V1/Delete?conversionId=${conversionId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// ASSIGN TO FLOOR & RACK
// ═══════════════════════════════════════════════════════════════════════════════
export const assignFloorRack = {
  getAll: () => api.get('/api/AssignFloorRack/api/V1/GetAllAssignments'),
  getById: (itemCode) => api.get(`/api/AssignFloorRack/api/V1/GetAssignmentByItem?itemCode=${itemCode}`),
  save: (data) => api.post('/api/AssignFloorRack/api/V1/Save', data),
  update: (data) => api.put('/api/AssignFloorRack/api/V1/Update', data),
};

// ═══════════════════════════════════════════════════════════════════════════════
// HSN CODE UPDATE
// ═══════════════════════════════════════════════════════════════════════════════
export const hsnCodeUpdate = {
  getAll: () => api.get('/api/HSNCodeUpdate/api/V1/GetAllItems'),
  update: (data) => api.put('/api/HSNCodeUpdate/api/V1/Update', data),
  bulkUpdate: (data) => api.post('/api/HSNCodeUpdate/api/V1/BulkUpdate', data),
};

// ═══════════════════════════════════════════════════════════════════════════════
// PRICE PRINT BARCODE
// ═══════════════════════════════════════════════════════════════════════════════
export const pricePrintBarcode = {
  getItems: () => api.get('/api/PricePrintBarcode/api/V1/GetItemsForPrint'),
  generateLabels: (data) => api.post('/api/PricePrintBarcode/api/V1/GenerateLabels', data),
  printLabels: (data) => api.post('/api/PricePrintBarcode/api/V1/PrintLabels', data),
};

// ═══════════════════════════════════════════════════════════════════════════════
// STOCK MOVEMENT REPORT
// ═══════════════════════════════════════════════════════════════════════════════
export const stockMovement = {
  getReport: (branchId, fromDate, toDate) => 
    api.get(`/api/StockMovement/api/V1/GetReport?branchId=${branchId}&fromDate=${fromDate}&toDate=${toDate}`),
  getMonthlyReport: (branchId, year, month) => 
    api.get(`/api/StockMovement/api/V1/GetMonthlyReport?branchId=${branchId}&year=${year}&month=${month}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// STOCK LEDGER
// ═══════════════════════════════════════════════════════════════════════════════
export const stockLedger = {
  getReport: (itemCode, branchId, fromDate, toDate) => 
    api.get(`/api/StockLedger/api/V1/GetReport?itemCode=${itemCode}&branchId=${branchId}&fromDate=${fromDate}&toDate=${toDate}`),
  getWithDC: (itemCode, branchId, fromDate, toDate) => 
    api.get(`/api/StockLedger/api/V1/GetReportWithDC?itemCode=${itemCode}&branchId=${branchId}&fromDate=${fromDate}&toDate=${toDate}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// CLOSING STOCK
// ═══════════════════════════════════════════════════════════════════════════════
export const closingStock = {
  getReport: (branchId, asOnDate) => 
    api.get(`/api/ClosingStock/api/V1/GetReport?branchId=${branchId}&asOnDate=${asOnDate}`),
  getWithPurchase: (branchId, asOnDate) => 
    api.get(`/api/ClosingStock/api/V1/GetReportWithPurchase?branchId=${branchId}&asOnDate=${asOnDate}`),
  getAuditor: (branchId, asOnDate) => 
    api.get(`/api/ClosingStock/api/V1/GetAuditorReport?branchId=${branchId}&asOnDate=${asOnDate}`),
  getWithDC: (branchId, asOnDate) => 
    api.get(`/api/ClosingStock/api/V1/GetReportWithDC?branchId=${branchId}&asOnDate=${asOnDate}`),
  getImageReport: (branchId, asOnDate) => 
    api.get(`/api/ClosingStock/api/V1/GetImageReport?branchId=${branchId}&asOnDate=${asOnDate}`),
  getFloorWise: (branchId, floorId, asOnDate) => 
    api.get(`/api/ClosingStock/api/V1/GetFloorWiseReport?branchId=${branchId}&floorId=${floorId}&asOnDate=${asOnDate}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// STOCK ANALYSIS REPORT
// ═══════════════════════════════════════════════════════════════════════════════
export const stockAnalysis = {
  getReport: (branchId, fromDate, toDate) => 
    api.get(`/api/StockAnalysis/api/V1/GetReport?branchId=${branchId}&fromDate=${fromDate}&toDate=${toDate}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// BARCODE ITEM INFORMATION
// ═══════════════════════════════════════════════════════════════════════════════
export const barcodeItemInfo = {
  getByBarcode: (barcode) => api.get(`/api/BarcodeItemInfo/api/V1/GetByBarcode?barcode=${barcode}`),
  getByItemCode: (itemCode) => api.get(`/api/BarcodeItemInfo/api/V1/GetByItemCode?itemCode=${itemCode}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// PURCHASE SUMMARY REPORTS
// ═══════════════════════════════════════════════════════════════════════════════
export const purchaseSummary = {
  getReport: (branchId, fromDate, toDate) => 
    api.get(`/api/PurchaseSummary/api/V1/GetReport?branchId=${branchId}&fromDate=${fromDate}&toDate=${toDate}`),
  getPartyInfo: (supplierId, fromDate, toDate) => 
    api.get(`/api/PurchaseSummary/api/V1/GetPartyInfo?supplierId=${supplierId}&fromDate=${fromDate}&toDate=${toDate}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// INVOICE WISE OUTSTANDING REPORT
// ═══════════════════════════════════════════════════════════════════════════════
export const invoiceOutstanding = {
  getReport: (supplierId, asOnDate) => 
    api.get(`/api/InvoiceOutstanding/api/V1/GetReport?supplierId=${supplierId}&asOnDate=${asOnDate}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// SUPPLIER WISE AGEING REPORT
// ═══════════════════════════════════════════════════════════════════════════════
export const supplierAgeing = {
  getReport: (asOnDate) => api.get(`/api/SupplierAgeing/api/V1/GetReport?asOnDate=${asOnDate}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// OPENING STOCK IMPORT
// ═══════════════════════════════════════════════════════════════════════════════
export const openingStockImport = {
  getTemplate: () => api.get('/api/OpeningStockImport/api/V1/GetTemplate'),
  uploadFile: (data) => api.post('/api/OpeningStockImport/api/V1/Upload', data),
  processImport: (data) => api.post('/api/OpeningStockImport/api/V1/Process', data),
  getWithSupplier: () => api.get('/api/OpeningStockImport/api/V1/GetWithSupplier'),
};

// ═══════════════════════════════════════════════════════════════════════════════
// MATERIAL RECEIPT IMPORT
// ═══════════════════════════════════════════════════════════════════════════════
export const materialReceiptImport = {
  uploadFile: (data) => api.post('/api/MaterialReceiptImport/api/V1/Upload', data),
  processImport: (data) => api.post('/api/MaterialReceiptImport/api/V1/Process', data),
};

// ═══════════════════════════════════════════════════════════════════════════════
// STOCK EXPORT TO BRANCH
// ═══════════════════════════════════════════════════════════════════════════════
export const stockExportBranch = {
  getAll: () => api.get('/api/StockExportBranch/api/V1/GetAllExports'),
  getById: (exportId) => api.get(`/api/StockExportBranch/api/V1/GetExportById?exportId=${exportId}`),
  save: (data) => api.post('/api/StockExportBranch/api/V1/Save', data),
  process: (data) => api.post('/api/StockExportBranch/api/V1/Process', data),
};

// ═══════════════════════════════════════════════════════════════════════════════
// STOCK RETURN FROM BRANCH
// ═══════════════════════════════════════════════════════════════════════════════
export const stockReturnBranch = {
  getAllOffline: () => api.get('/api/StockReturnBranch/api/V1/GetAllOffline'),
  getAllOnline: () => api.get('/api/StockReturnBranch/api/V1/GetAllOnline'),
  getById: (returnId) => api.get(`/api/StockReturnBranch/api/V1/GetById?returnId=${returnId}`),
  save: (data) => api.post('/api/StockReturnBranch/api/V1/Save', data),
  importAtWarehouse: (data) => api.post('/api/StockReturnBranch/api/V1/ImportAtWarehouse', data),
};

// ═══════════════════════════════════════════════════════════════════════════════
// STOCK RETURN TO WAREHOUSE
// ═══════════════════════════════════════════════════════════════════════════════
export const stockReturnWarehouse = {
  getAll: () => api.get('/api/StockReturnWarehouse/api/V1/GetAll'),
  getById: (returnId) => api.get(`/api/StockReturnWarehouse/api/V1/GetById?returnId=${returnId}`),
  save: (data) => api.post('/api/StockReturnWarehouse/api/V1/Save', data),
};

// ═══════════════════════════════════════════════════════════════════════════════
// STOCK IMPORT FROM WAREHOUSE
// ═══════════════════════════════════════════════════════════════════════════════
export const stockImportWarehouse = {
  getAllOffline: () => api.get('/api/StockImportWarehouse/api/V1/GetAllOffline'),
  getAllOnline: () => api.get('/api/StockImportWarehouse/api/V1/GetAllOnline'),
  getById: (importId) => api.get(`/api/StockImportWarehouse/api/V1/GetById?importId=${importId}`),
  process: (data) => api.post('/api/StockImportWarehouse/api/V1/Process', data),
};

// ═══════════════════════════════════════════════════════════════════════════════
// SALES EXPORT
// ═══════════════════════════════════════════════════════════════════════════════
export const salesExport = {
  exportToWarehouse: (branchId, fromDate, toDate) => 
    api.get(`/api/SalesExport/api/V1/ExportToWarehouse?branchId=${branchId}&fromDate=${fromDate}&toDate=${toDate}`),
  exportToExcel: (branchId, fromDate, toDate) => 
    api.get(`/api/SalesExport/api/V1/ExportToExcel?branchId=${branchId}&fromDate=${fromDate}&toDate=${toDate}`),
  importFromExcel: (data) => api.post('/api/SalesExport/api/V1/ImportFromExcel', data),
};

// ═══════════════════════════════════════════════════════════════════════════════
// BRANCH REPORTS
// ═══════════════════════════════════════════════════════════════════════════════
export const branchReports = {
  stockMovement: (branchId, fromDate, toDate) => 
    api.get(`/api/BranchReports/api/V1/StockMovement?branchId=${branchId}&fromDate=${fromDate}&toDate=${toDate}`),
  branchWiseStock: (asOnDate) => 
    api.get(`/api/BranchReports/api/V1/BranchWiseStock?asOnDate=${asOnDate}`),
  stockTransfer: (branchId, fromDate, toDate) => 
    api.get(`/api/BranchReports/api/V1/StockTransfer?branchId=${branchId}&fromDate=${fromDate}&toDate=${toDate}`),
  posInfo: (branchId, fromDate, toDate) => 
    api.get(`/api/BranchReports/api/V1/POSInfo?branchId=${branchId}&fromDate=${fromDate}&toDate=${toDate}`),
  billToBill: (branchId, fromDate, toDate) => 
    api.get(`/api/BranchReports/api/V1/BillToBill?branchId=${branchId}&fromDate=${fromDate}&toDate=${toDate}`),
  bulkInvoicePrint: (branchId, fromDate, toDate) => 
    api.get(`/api/BranchReports/api/V1/BulkInvoicePrint?branchId=${branchId}&fromDate=${fromDate}&toDate=${toDate}`),
  daySheet: (branchId, date) => 
    api.get(`/api/BranchReports/api/V1/DaySheet?branchId=${branchId}&date=${date}`),
  posCancelReport: (branchId, fromDate, toDate) => 
    api.get(`/api/BranchReports/api/V1/POSCancelReport?branchId=${branchId}&fromDate=${fromDate}&toDate=${toDate}`),
  taxRegister: (branchId, fromDate, toDate) => 
    api.get(`/api/BranchReports/api/V1/TaxRegister?branchId=${branchId}&fromDate=${fromDate}&toDate=${toDate}`),
  customerSales: (branchId, fromDate, toDate) => 
    api.get(`/api/BranchReports/api/V1/CustomerSales?branchId=${branchId}&fromDate=${fromDate}&toDate=${toDate}`),
  productAgeing: (branchId, asOnDate) => 
    api.get(`/api/BranchReports/api/V1/ProductAgeing?branchId=${branchId}&asOnDate=${asOnDate}`),
  fastMovingItems: (branchId, fromDate, toDate) => 
    api.get(`/api/BranchReports/api/V1/FastMovingItems?branchId=${branchId}&fromDate=${fromDate}&toDate=${toDate}`),
  eodReport: (branchId, date) => 
    api.get(`/api/BranchReports/api/V1/EODReport?branchId=${branchId}&date=${date}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// FRANCHISE OPERATIONS
// ═══════════════════════════════════════════════════════════════════════════════
export const franchiseOps = {
  stockExport: (franchiseId, data) => 
    api.post(`/api/Franchise/api/V1/StockExport?franchiseId=${franchiseId}`, data),
  stockImport: (franchiseId) => 
    api.get(`/api/Franchise/api/V1/StockImport?franchiseId=${franchiseId}`),
  stockImportOnline: (franchiseId) => 
    api.get(`/api/Franchise/api/V1/StockImportOnline?franchiseId=${franchiseId}`),
  stockReturn: (franchiseId) => 
    api.get(`/api/Franchise/api/V1/StockReturn?franchiseId=${franchiseId}`),
  salesImport: (franchiseId, data) => 
    api.post(`/api/Franchise/api/V1/SalesImport?franchiseId=${franchiseId}`, data),
};

// ═══════════════════════════════════════════════════════════════════════════════
// FRANCHISE REPORTS
// ═══════════════════════════════════════════════════════════════════════════════
export const franchiseReports = {
  stockExportReport: (franchiseId, fromDate, toDate) => 
    api.get(`/api/FranchiseReports/api/V1/StockExport?franchiseId=${franchiseId}&fromDate=${fromDate}&toDate=${toDate}`),
  salesSummary: (franchiseId, fromDate, toDate) => 
    api.get(`/api/FranchiseReports/api/V1/SalesSummary?franchiseId=${franchiseId}&fromDate=${fromDate}&toDate=${toDate}`),
  stockAndSales: (franchiseId, fromDate, toDate) => 
    api.get(`/api/FranchiseReports/api/V1/StockAndSales?franchiseId=${franchiseId}&fromDate=${fromDate}&toDate=${toDate}`),
  productProfitability: (franchiseId, fromDate, toDate) => 
    api.get(`/api/FranchiseReports/api/V1/ProductProfitability?franchiseId=${franchiseId}&fromDate=${fromDate}&toDate=${toDate}`),
  invoiceReport: (franchiseId, fromDate, toDate) => 
    api.get(`/api/FranchiseReports/api/V1/InvoiceReport?franchiseId=${franchiseId}&fromDate=${fromDate}&toDate=${toDate}`),
  markdownProfit: (franchiseId, fromDate, toDate) => 
    api.get(`/api/FranchiseReports/api/V1/MarkdownProfit?franchiseId=${franchiseId}&fromDate=${fromDate}&toDate=${toDate}`),
  groupWiseSales: (franchiseId, fromDate, toDate) => 
    api.get(`/api/FranchiseReports/api/V1/GroupWiseSales?franchiseId=${franchiseId}&fromDate=${fromDate}&toDate=${toDate}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// SHOP OPERATIONS
// ═══════════════════════════════════════════════════════════════════════════════
export const shopOps = {
  stockTransfer: (shopId, data) => 
    api.post(`/api/Shop/api/V1/StockTransfer?shopId=${shopId}`, data),
  stockReturn: (shopId, data) => 
    api.post(`/api/Shop/api/V1/StockReturn?shopId=${shopId}`, data),
  salesImport: (shopId, data) => 
    api.post(`/api/Shop/api/V1/SalesImport?shopId=${shopId}`, data),
};

// ═══════════════════════════════════════════════════════════════════════════════
// SHOP REPORTS
// ═══════════════════════════════════════════════════════════════════════════════
export const shopReports = {
  stockTransfer: (shopId, fromDate, toDate) => 
    api.get(`/api/ShopReports/api/V1/StockTransfer?shopId=${shopId}&fromDate=${fromDate}&toDate=${toDate}`),
  posInfo: (shopId, fromDate, toDate) => 
    api.get(`/api/ShopReports/api/V1/POSInfo?shopId=${shopId}&fromDate=${fromDate}&toDate=${toDate}`),
  sales: (shopId, fromDate, toDate) => 
    api.get(`/api/ShopReports/api/V1/Sales?shopId=${shopId}&fromDate=${fromDate}&toDate=${toDate}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// MIS REPORTS
// ═══════════════════════════════════════════════════════════════════════════════
export const misReports = {
  productProfitability: (branchId, fromDate, toDate) => 
    api.get(`/api/MISReports/api/V1/ProductProfitability?branchId=${branchId}&fromDate=${fromDate}&toDate=${toDate}`),
  productProfitabilityNew: (branchId, fromDate, toDate) => 
    api.get(`/api/MISReports/api/V1/ProductProfitabilityNew?branchId=${branchId}&fromDate=${fromDate}&toDate=${toDate}`),
  productAgeing: (branchId, asOnDate) => 
    api.get(`/api/MISReports/api/V1/ProductAgeing?branchId=${branchId}&asOnDate=${asOnDate}`),
  fastMovingItems: (branchId, fromDate, toDate) => 
    api.get(`/api/MISReports/api/V1/FastMovingItems?branchId=${branchId}&fromDate=${fromDate}&toDate=${toDate}`),
  expiryItems: (branchId, asOnDate) => 
    api.get(`/api/MISReports/api/V1/ExpiryItems?branchId=${branchId}&asOnDate=${asOnDate}`),
  supplierPerformance: (supplierId, fromDate, toDate) => 
    api.get(`/api/MISReports/api/V1/SupplierPerformance?supplierId=${supplierId}&fromDate=${fromDate}&toDate=${toDate}`),
  purchaseProfitability: (branchId, fromDate, toDate) => 
    api.get(`/api/MISReports/api/V1/PurchaseProfitability?branchId=${branchId}&fromDate=${fromDate}&toDate=${toDate}`),
  mrpWisePurchaseSales: (branchId, fromDate, toDate) => 
    api.get(`/api/MISReports/api/V1/MRPWisePurchaseSales?branchId=${branchId}&fromDate=${fromDate}&toDate=${toDate}`),
  smProductProfitability: (salesManId, fromDate, toDate) => 
    api.get(`/api/MISReports/api/V1/SMProductProfitability?salesManId=${salesManId}&fromDate=${fromDate}&toDate=${toDate}`),
};

export default {
  stockVerifySchedule,
  stockVerifyEntry,
  verifyUpdateStock,
  shortageStock,
  excessStock,
  physicalStockPDA,
  rolSettings,
  priceUpdate,
  tokenUpdate,
  bulkProductUpdation,
  oemCodeUpdate,
  itemConversion,
  assignFloorRack,
  hsnCodeUpdate,
  pricePrintBarcode,
  stockMovement,
  stockLedger,
  closingStock,
  stockAnalysis,
  barcodeItemInfo,
  purchaseSummary,
  invoiceOutstanding,
  supplierAgeing,
  openingStockImport,
  materialReceiptImport,
  stockExportBranch,
  stockReturnBranch,
  stockReturnWarehouse,
  stockImportWarehouse,
  salesExport,
  branchReports,
  franchiseOps,
  franchiseReports,
  shopOps,
  shopReports,
  misReports,
};
